const HealthImageEnum = Object.freeze({
    MEAL_RECORD: { value: 0, text: '食事記録' },
    EXAMINATION_DATA: { value: 1, text: '検診データ' },
    OTHER: { value: 2, text: 'その他' },
});

export default HealthImageEnum;
